import slaydApi from './axiosInstance';

interface CreateDeeplinkForUrlPayload {
  url: string;
  title?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
}

interface CreateDeeplinkResponse {
  success: boolean;
  originalUrl: string;
  deepLink: string;
}

export const createDeeplinkForUrl = async (
  params: CreateDeeplinkForUrlPayload
): Promise<CreateDeeplinkResponse> => {
  try {
    if (!params.url) {
      throw new Error('url parameter is required');
    }

    const requestBody: Record<string, string> = {
      url: params.url,
    };

    if (params.title) requestBody.title = params.title;
    if (params.utmSource) requestBody.utmSource = params.utmSource;
    if (params.utmMedium) requestBody.utmMedium = params.utmMedium;
    if (params.utmCampaign) requestBody.utmCampaign = params.utmCampaign;
    if (params.utmTerm) requestBody.utmTerm = params.utmTerm;
    if (params.utmContent) requestBody.utmContent = params.utmContent;

    const response = await slaydApi.post<CreateDeeplinkResponse>(
      '/api/create-deep-link/',
      requestBody
    );

    if (!response?.data?.deepLink) {
      throw new Error('Invalid response: missing deeplink');
    }

    return response.data;
  } catch (error) {
    console.error('Error creating deeplink: ', error);
    throw new Error('Error creating deeplink');
  }
};
